import { Model } from "@vuex-orm/core";
import shortid from "shortid";
import store from "../store";

export default class PhoneLine extends Model {
  static entity = "phoneLines";
  static fields() {
    return {
      id: this.attr("tmp/" + shortid.generate()),
      companyId: this.attr(null),
      dateCreated: this.attr(null),
      dateRemoved: this.attr(null),
      dateUpdated: this.attr(null),
      name: this.attr(null),
      isDefault: this.attr(null),
      status: this.attr('active')
    }
  }

  static beforeCreate(model) {
    if(!model.companyId) model.companyId = store.state.auth.user.defaultCompanyId
  }

  static afterCreate(model) {
    if(model.name) model.name = model.name.replace(/_/g, ' ')
  }

}
